package org.ksdfv.thelema.kxjs.audio

import org.w3c.dom.HTMLAudioElement

/** @author zeganstyl */
class SoundInstance(
    val element: HTMLAudioElement,
    val source: MediaElementAudioSourceNode,
    val gain: GainNode,
    val panner: StereoPannerNode
)